import React, { useEffect, useState, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface CarouselProps {
  images: {
    src: string;
    alt: string;
  }[];
  autoplay?: boolean;
  interval?: number;
}
export const Carousel = ({
  images,
  autoplay = true,
  interval = 5000
}: CarouselProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const goToNext = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
  };
  const goToPrev = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + images.length) % images.length);
  };
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };
  useEffect(() => {
    if (!autoplay) return;
    const timer = setInterval(goToNext, interval);
    return () => clearInterval(timer);
  }, [autoplay, interval]);
  return <div className="relative rounded-lg overflow-hidden shadow-lg" data-id="element-348" data-mp="28na2n9cxyie2">
      <div className="overflow-hidden relative aspect-[16/9]" data-id="element-349" data-mp="24lezs0fd3wy6">
        {images.map((image, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-500 ${index === currentIndex ? 'opacity-100' : 'opacity-0'}`} data-id="element-350" data-mp="12429ql3iy9hq" data-mpi={index}>
            <img src={image.src} alt={image.alt} className="w-full h-full object-cover" loading={index === 0 ? 'eager' : 'lazy'} style={{
          maxWidth: '100%',
          height: 'auto'
        }} data-id="element-351" data-mp="165w2863kg76t" />
          </div>)}
        <button onClick={goToPrev} className="absolute left-4 top-1/2 transform -translate-y-1/2 p-2 bg-white/80 border border-gray-200 hover:bg-white hover:border-primary rounded-full shadow-md transition-colors" data-id="element-352" data-mp="1g1h3u34q35g1">
          <ChevronLeft size={24} className="text-secondary hover:text-primary" data-id="element-353" data-mp="1tuyj3bqdlw09" />
        </button>
        <button onClick={goToNext} className="absolute right-4 top-1/2 transform -translate-y-1/2 p-2 bg-white/80 border border-gray-200 hover:bg-white hover:border-primary rounded-full shadow-md transition-colors" data-id="element-354" data-mp="1yu1pp0m08aac">
          <ChevronRight size={24} className="text-secondary hover:text-primary" data-id="element-355" data-mp="28rplzuz9dpum" />
        </button>
      </div>
      <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2" data-id="element-356" data-mp="1j3afp7o93ya3">
        {images.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-3 h-3 rounded-full border border-white ${index === currentIndex ? 'bg-primary border-primary' : 'bg-white/70'}`} data-id="element-357" data-mp="1e61uey7t3e4m" data-mpi={index} />)}
      </div>
    </div>;
};